var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.MODAL_ID,
            title: _vm.modalTitle,
            size: "xl",
            scrollable: "",
            "dialog-class": "make-editable-modal-dialog",
            "body-class": "make-editable-modal-body",
            "hide-footer": _vm.currentStep !== 2 && !_vm.isLoading,
            "footer-class": "make-editable-progress-footer",
            "no-close-on-backdrop": "",
            "no-close-on-esc": _vm.isAnalyzingRegion,
            "hide-header-close": _vm.isAnalyzingRegion,
          },
          on: { show: _vm.onModalOpen, hide: _vm.onModalHide },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c("div", { staticClass: "w-100" }, [
                    _vm.isLoading
                      ? _c(
                          "div",
                          { staticClass: "px-3 py-2" },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center mb-2" },
                              [
                                _c("span", {
                                  staticClass:
                                    "spinner-border spinner-border-sm mr-2",
                                  attrs: {
                                    role: "status",
                                    "aria-hidden": "true",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(_vm.progressText))]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("b-progress", {
                              staticStyle: { height: "6px" },
                              attrs: {
                                value: _vm.progressPercent,
                                max: 100,
                                animated: "",
                                variant: "info",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentStep === 2
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center px-3 py-2 border-top",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        _vm.isLoading || _vm.isAnalyzingRegion,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.currentStep = 1
                                      },
                                    },
                                  },
                                  [_vm._v("\n              Back\n            ")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-warning ml-2",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        _vm.isLoading || _vm.isAnalyzingRegion,
                                    },
                                    on: { click: _vm.handleReanalyze },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-redo mr-1",
                                    }),
                                    _vm._v("Re-analyze\n            "),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  type: "button",
                                  disabled:
                                    _vm.isLoading ||
                                    _vm.isAnalyzingRegion ||
                                    (_vm.translateExtractedText &&
                                      _vm.translateTargetLanguages.length ===
                                        0),
                                },
                                on: { click: _vm.handleRemoveText },
                              },
                              [
                                _vm.isLoading
                                  ? _c("span", {
                                      staticClass:
                                        "spinner-border spinner-border-sm mr-2",
                                      attrs: {
                                        role: "status",
                                        "aria-hidden": "true",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.isLoading
                                        ? "Processing..."
                                        : "Make Editable"
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.currentStep === 1
            ? _c(
                "div",
                { staticClass: "step-one-content" },
                [
                  _c(
                    "div",
                    { staticClass: "form-group mb-4" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center mb-2",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "mb-0",
                              attrs: { for: "backgroundImageSelectV2" },
                            },
                            [
                              _vm._v(
                                "Select Image(s) (" +
                                  _vm._s(_vm.selectedTemplates.length) +
                                  " selected)"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "a",
                              {
                                staticClass: "text-secondary small mr-2",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.selectAllFirstImages.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v("Select all")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "text-secondary small",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.selectedTemplates = []
                                  },
                                },
                              },
                              [_vm._v("Clear")]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("Multiselect", {
                        staticClass: "image-select-dropdown",
                        attrs: {
                          id: "backgroundImageSelectV2",
                          options: _vm.groupedBackgroundImages,
                          multiple: true,
                          "close-on-select": false,
                          "clear-on-select": false,
                          "group-select": true,
                          "group-label": "instanceId",
                          "group-values": "images",
                          placeholder: "Select images",
                          label: "text",
                          "track-by": "value",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "option",
                              fn: function (props) {
                                return [
                                  props.option.$isLabel
                                    ? _c(
                                        "div",
                                        { staticClass: "template-group-label" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.getTemplateGroupName(
                                                  props.option.$groupLabel
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                        },
                                        [
                                          props.option.thumbnail
                                            ? _c("img", {
                                                staticClass:
                                                  "image-thumbnail mr-2",
                                                attrs: {
                                                  src: props.option.thumbnail,
                                                  alt: "",
                                                },
                                              })
                                            : _c("span", {
                                                staticClass:
                                                  "image-thumbnail-placeholder mr-2",
                                              }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(props.option.text)),
                                          ]),
                                        ]
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2429322556
                        ),
                        model: {
                          value: _vm.selectedTemplates,
                          callback: function ($$v) {
                            _vm.selectedTemplates = $$v
                          },
                          expression: "selectedTemplates",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "selected-images-preview mb-4 d-flex justify-content-start align-items-center pb-3",
                    },
                    _vm._l(_vm.selectedTemplates, function (template) {
                      return _c(
                        "div",
                        {
                          key: template.value,
                          staticClass:
                            "d-inline-flex flex-column align-items-center",
                        },
                        [
                          _c("img", {
                            staticClass: "img-fluid border rounded shadow-sm",
                            staticStyle: {
                              "max-height": "400px",
                              "object-fit": "contain",
                              "max-width": "none",
                            },
                            attrs: { src: template.url, alt: template.text },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "small text-muted text-center mt-2 text-truncate",
                              staticStyle: { "max-width": "300px" },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(template.text) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "mb-4",
                      attrs: { disabled: _vm.isLoading },
                      model: {
                        value: _vm.createNewTemplatesForEditableImages,
                        callback: function ($$v) {
                          _vm.createNewTemplatesForEditableImages = $$v
                        },
                        expression: "createNewTemplatesForEditableImages",
                      },
                    },
                    [
                      _vm._v(
                        "\n        Create new templates for the editable images\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-alert",
                    {
                      staticClass: "mb-3",
                      attrs: {
                        show: !!_vm.errorMessage,
                        variant: "danger",
                        dismissible: "",
                      },
                      on: {
                        dismissed: function ($event) {
                          _vm.errorMessage = ""
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.errorMessage) + "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end mt-4" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            type: "button",
                            disabled:
                              _vm.selectedTemplates.length === 0 ||
                              _vm.isLoading,
                          },
                          on: { click: _vm.handleExtractText },
                        },
                        [
                          _vm.isLoading
                            ? _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm mr-2",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.isLoading
                                  ? "Analyzing..."
                                  : _vm.areAllSelectedImagesCached
                                  ? "Continue"
                                  : "Analyze Image(s)"
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentStep === 2
            ? _c(
                "div",
                [
                  _vm.selectedTemplates.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "template-navigation mb-3 p-2 border rounded d-flex justify-content-between align-items-center bg-light",
                        },
                        [
                          _c("div", [
                            _c("strong", [
                              _vm._v(
                                "Template " +
                                  _vm._s(_vm.currentTemplateIndex + 1) +
                                  " of " +
                                  _vm._s(_vm.selectedTemplates.length)
                              ),
                            ]),
                            _vm._v(
                              " — " +
                                _vm._s(_vm.currentTemplateOption?.text) +
                                "\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center gap-1" },
                            [
                              _vm._l(
                                _vm.selectedTemplates,
                                function (template, index) {
                                  return _c(
                                    "button",
                                    {
                                      key: template.value,
                                      staticClass:
                                        "btn btn-sm rounded-circle d-flex align-items-center justify-content-center p-0",
                                      class:
                                        index === _vm.currentTemplateIndex
                                          ? "btn-success text-white"
                                          : "btn-outline-secondary",
                                      staticStyle: {
                                        width: "24px",
                                        height: "24px",
                                        "font-size": "12px",
                                        "margin-left": "4px",
                                      },
                                      attrs: {
                                        disabled: _vm.isAnalyzingRegion,
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.currentTemplateIndex = index
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(index + 1) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm ml-2",
                                  attrs: {
                                    type: "button",
                                    disabled:
                                      _vm.currentTemplateIndex === 0 ||
                                      _vm.isAnalyzingRegion,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.currentTemplateIndex--
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "bi bi-chevron-left",
                                  }),
                                  _vm._v(" Prev\n          "),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  attrs: {
                                    type: "button",
                                    disabled:
                                      _vm.currentTemplateIndex >=
                                        Math.max(
                                          0,
                                          _vm.selectedTemplates.length - 1
                                        ) || _vm.isAnalyzingRegion,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.currentTemplateIndex++
                                    },
                                  },
                                },
                                [
                                  _vm._v("\n            Next "),
                                  _c("i", {
                                    staticClass: "bi bi-chevron-right",
                                  }),
                                ]
                              ),
                            ],
                            2
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mb-2 align-items-center" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-5 d-flex justify-content-between align-items-center",
                      },
                      [
                        _c("h6", { staticClass: "mb-0 font-weight-bold" }, [
                          _vm._v("\n            Detected Texts\n          "),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "small" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-link btn-sm p-0 mr-2 text-success font-weight-bold",
                              staticStyle: { "text-decoration": "none" },
                              on: { click: _vm.selectAllTexts },
                            },
                            [_vm._v("\n              Select All\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-link btn-sm p-0 text-danger font-weight-bold",
                              staticStyle: { "text-decoration": "none" },
                              on: { click: _vm.deselectAutomaticTexts },
                            },
                            [
                              _vm._v(
                                "\n              Deselect All\n            "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-7" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center",
                        },
                        [
                          _c("h6", { staticClass: "mb-0 font-weight-bold" }, [
                            _vm._v("\n              Preview\n            "),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm",
                              class: _vm.drawingMode
                                ? "btn-primary"
                                : "btn-outline-primary",
                              attrs: {
                                type: "button",
                                disabled:
                                  _vm.isLoading ||
                                  _vm.isAnalyzingRegion ||
                                  !_vm.nativeWidth ||
                                  !_vm.nativeHeight,
                              },
                              on: { click: _vm.toggleDrawingMode },
                            },
                            [
                              _vm.isAnalyzingRegion
                                ? _c("span", {
                                    staticClass:
                                      "spinner-border spinner-border-sm mr-1",
                                  })
                                : _c("i", {
                                    staticClass: "bi bi-bounding-box mr-1",
                                  }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.isAnalyzingRegion
                                      ? "Analyzing..."
                                      : _vm.drawingMode
                                      ? "Cancel drawing"
                                      : "Add missing text"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row align-items-stretch" }, [
                    _c("div", { staticClass: "col-md-5 d-flex flex-column" }, [
                      _c("p", { staticClass: "small text-muted mb-2" }, [
                        _vm._v(
                          "\n            Select the text you want to make editable. Expand a row to adjust color, size or font.\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-list-container mb-3 flex-grow-1 d-flex flex-column",
                          style: {
                            height: "500px",
                            maxHeight: _vm.isLoading ? "60vh" : "70vh",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              key: `text-list-${_vm.analysisRenderRevision}`,
                              staticClass: "text-list-scroll flex-grow-1",
                              staticStyle: {
                                "overflow-y": "auto",
                                "min-height": "0",
                              },
                            },
                            _vm._l(_vm.extractedTexts, function (tp, index) {
                              return _c(
                                "div",
                                {
                                  key: tp._clientId,
                                  ref: "textRow-" + tp._clientId,
                                  refInFor: true,
                                  staticClass: "detected-text-row",
                                  class: {
                                    "is-hovered": _vm.hoveredIndex === index,
                                    "active-text-row":
                                      _vm.activeTextId === tp._clientId,
                                    "is-selected": _vm.isTextSelected(index),
                                  },
                                  on: {
                                    mouseenter: function ($event) {
                                      _vm.hoveredIndex = index
                                    },
                                    mouseleave: function ($event) {
                                      _vm.hoveredIndex = null
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "detected-text-row__header",
                                      attrs: {
                                        role: "button",
                                        tabindex: "0",
                                        "aria-expanded": _vm.isTextExpanded(
                                          tp._clientId
                                        )
                                          ? "true"
                                          : "false",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleTextDetails(
                                            tp._clientId
                                          )
                                        },
                                        keydown: [
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            return _vm.toggleTextDetails(
                                              tp._clientId
                                            )
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "space",
                                                32,
                                                $event.key,
                                                [" ", "Spacebar"]
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                            return _vm.toggleTextDetails(
                                              tp._clientId
                                            )
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "custom-control custom-checkbox flex-grow-1",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.selectedIndices,
                                                expression: "selectedIndices",
                                              },
                                            ],
                                            staticClass: "custom-control-input",
                                            attrs: {
                                              id: "tp-" + tp._clientId,
                                              type: "checkbox",
                                              disabled: tp._manual,
                                            },
                                            domProps: {
                                              value: index,
                                              checked: Array.isArray(
                                                _vm.selectedIndices
                                              )
                                                ? _vm._i(
                                                    _vm.selectedIndices,
                                                    index
                                                  ) > -1
                                                : _vm.selectedIndices,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a = _vm.selectedIndices,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = index,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.selectedIndices =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.selectedIndices = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.selectedIndices = $$c
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "custom-control-label cursor-pointer w-100",
                                              attrs: {
                                                for: "tp-" + tp._clientId,
                                              },
                                            },
                                            [
                                              _c(
                                                "strong",
                                                {
                                                  style: {
                                                    fontFamily:
                                                      tp.font || "inherit",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    '"' +
                                                      _vm._s(tp.content) +
                                                      '"'
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      tp._manual
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-link btn-sm text-danger p-1 ml-2",
                                              attrs: {
                                                type: "button",
                                                title:
                                                  "Delete manual text region",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.deleteManualText(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "bi bi-trash",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "detected-text-row__toggle",
                                          attrs: {
                                            type: "button",
                                            "aria-label": _vm.isTextExpanded(
                                              tp._clientId
                                            )
                                              ? "Collapse text details"
                                              : "Expand text details",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.toggleTextDetails(
                                                tp._clientId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            class: [
                                              "bi",
                                              _vm.isTextExpanded(tp._clientId)
                                                ? "bi-chevron-up"
                                                : "bi-chevron-down",
                                            ],
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.isTextExpanded(tp._clientId)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "detected-text-row__details",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "detected-text-row__metadata",
                                            },
                                            [
                                              _c("span", [_vm._v("Color")]),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: tp.color,
                                                    expression: "tp.color",
                                                  },
                                                ],
                                                staticClass:
                                                  "detected-text-row__color",
                                                attrs: {
                                                  type: "color",
                                                  title: `Text color: ${
                                                    tp.color || "#000000"
                                                  }`,
                                                  "aria-label": "Text color",
                                                },
                                                domProps: { value: tp.color },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      tp,
                                                      "color",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "detected-text-row__separator",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "detected-text-row__size mb-0",
                                                },
                                                [
                                                  _c("span", [_vm._v("Size:")]),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName:
                                                          "v-model.number",
                                                        value: tp.font_size,
                                                        expression:
                                                          "tp.font_size",
                                                        modifiers: {
                                                          number: true,
                                                        },
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                      min: "1",
                                                      step: "1",
                                                      "aria-label": "Font size",
                                                    },
                                                    domProps: {
                                                      value: tp.font_size,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.roundFontSize(
                                                          tp
                                                        )
                                                      },
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          tp,
                                                          "font_size",
                                                          _vm._n(
                                                            $event.target.value
                                                          )
                                                        )
                                                      },
                                                      blur: function ($event) {
                                                        return _vm.$forceUpdate()
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [_vm._v("px")]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("FontSelector", {
                                            staticClass:
                                              "detected-text-row__font",
                                            attrs: { "all-fonts": true },
                                            model: {
                                              value: tp.font,
                                              callback: function ($$v) {
                                                _vm.$set(tp, "font", $$v)
                                              },
                                              expression: "tp.font",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "make-editable-options flex-shrink-0",
                            },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    disabled:
                                      _vm.isLoading ||
                                      !_vm.createNewTemplatesForEditableImages,
                                  },
                                  model: {
                                    value: _vm.translateExtractedText,
                                    callback: function ($$v) {
                                      _vm.translateExtractedText = $$v
                                    },
                                    expression: "translateExtractedText",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Translate extracted text\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.createNewTemplatesForEditableImages
                                ? _c(
                                    "div",
                                    { staticClass: "small text-muted mt-1" },
                                    [
                                      _vm._v(
                                        "\n                Translation is available only when creating new templates.\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.translateExtractedText
                                ? _c(
                                    "div",
                                    { staticClass: "mt-2" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "font-weight-bold mb-1",
                                        },
                                        [_vm._v("Target language(s):")]
                                      ),
                                      _vm._v(" "),
                                      _c("Multiselect", {
                                        staticClass: "multiselect-translation",
                                        attrs: {
                                          options: _vm.availableLanguages,
                                          multiple: true,
                                          "close-on-select": true,
                                          taggable: false,
                                          disabled: _vm.isLoading,
                                          placeholder: "Select language(s)...",
                                        },
                                        model: {
                                          value: _vm.translateTargetLanguages,
                                          callback: function ($$v) {
                                            _vm.translateTargetLanguages = $$v
                                          },
                                          expression:
                                            "translateTargetLanguages",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.translateTargetLanguages.length === 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "small text-danger mt-1",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Select at least one target language.\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "advanced-toggle",
                                  attrs: {
                                    type: "button",
                                    "aria-expanded": _vm.isAdvancedOpen
                                      ? "true"
                                      : "false",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.isAdvancedOpen = !_vm.isAdvancedOpen
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Advanced\n                "
                                  ),
                                  _c("i", {
                                    class: [
                                      "bi",
                                      _vm.isAdvancedOpen
                                        ? "bi-chevron-up"
                                        : "bi-chevron-down",
                                    ],
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-collapse",
                                {
                                  model: {
                                    value: _vm.isAdvancedOpen,
                                    callback: function ($$v) {
                                      _vm.isAdvancedOpen = $$v
                                    },
                                    expression: "isAdvancedOpen",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "advanced-options" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "font-weight-bold mb-1",
                                          attrs: { for: "textRemovalMethodV2" },
                                        },
                                        [_vm._v("Text removal method")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "textRemovalMethodV2",
                                          options: _vm.textRemovalMethodOptions,
                                          disabled: _vm.isLoading,
                                        },
                                        model: {
                                          value: _vm.textRemovalMethod,
                                          callback: function ($$v) {
                                            _vm.textRemovalMethod = $$v
                                          },
                                          expression: "textRemovalMethod",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.textRemovalMethod === "opencv"
                                        ? _c(
                                            "b-form-checkbox",
                                            {
                                              staticClass: "mt-2 mb-0",
                                              attrs: {
                                                disabled: _vm.isLoading,
                                              },
                                              model: {
                                                value: _vm.enableAutoFallback,
                                                callback: function ($$v) {
                                                  _vm.enableAutoFallback = $$v
                                                },
                                                expression:
                                                  "enableAutoFallback",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "small" },
                                                [
                                                  _vm._v(
                                                    "Auto-fallback to GPT Image 2"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-7" }, [
                      _c("p", { staticClass: "small text-muted mb-2" }, [
                        _vm.drawingMode
                          ? _c("span", [
                              _vm._v(
                                "Drag over the complete missing text region."
                              ),
                            ])
                          : _c("span", [_vm._v(" ")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          ref: "previewContainer",
                          staticClass:
                            "preview-container border rounded position-relative text-center p-0",
                          style: {
                            background: "#e9ecef",
                            overflow: "auto",
                            minHeight: _vm.isLoading ? "0" : "500px",
                            maxHeight: _vm.isLoading ? "60vh" : "70vh",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "position-relative d-inline-block" },
                            [
                              _vm.selectedImage ||
                              (_vm.currentTemplateOption &&
                                _vm.currentTemplateOption.url)
                                ? _c("img", {
                                    key: _vm.currentTemplateOption
                                      ? `${_vm.currentTemplateOption.value}-${_vm.analysisRenderRevision}`
                                      : `img-${_vm.analysisRenderRevision}`,
                                    staticClass: "img-fluid",
                                    staticStyle: {
                                      display: "block",
                                      "max-width": "100%",
                                      height: "auto",
                                    },
                                    attrs: {
                                      src:
                                        _vm.selectedImage ||
                                        _vm.currentTemplateOption.url,
                                      alt: "Original Preview",
                                    },
                                    on: { load: _vm.onPreviewLoad },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.targetElement
                                ? _c(
                                    "svg",
                                    {
                                      ref: "previewOverlay",
                                      staticClass: "position-absolute",
                                      class: {
                                        "drawing-overlay": _vm.drawingMode,
                                      },
                                      style: {
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        pointerEvents: _vm.drawingMode
                                          ? "auto"
                                          : "none",
                                      },
                                      attrs: {
                                        viewBox: `0 0 ${_vm.nativeWidth} ${_vm.nativeHeight}`,
                                      },
                                      on: {
                                        pointerdown: _vm.startDrawing,
                                        pointermove: _vm.updateDrawing,
                                        pointerup: _vm.finishDrawing,
                                        pointercancel: _vm.cancelDrawing,
                                      },
                                    },
                                    [
                                      _vm._l(
                                        _vm.selectedIndices,
                                        function (idx) {
                                          return _c("rect", {
                                            key: "rect-" + idx,
                                            style: {
                                              pointerEvents: !_vm.drawingMode
                                                ? "all"
                                                : "none",
                                              cursor: "pointer",
                                            },
                                            attrs: {
                                              x: _vm.extractedTexts[idx].pos_x,
                                              y: _vm.extractedTexts[idx].pos_y,
                                              width:
                                                _vm.extractedTexts[idx].width,
                                              height:
                                                _vm.extractedTexts[idx].height,
                                              fill: "rgba(255, 193, 7, 0.2)",
                                              stroke: "#ffc107",
                                              "stroke-width": "4",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.focusText(idx)
                                              },
                                            },
                                          })
                                        }
                                      ),
                                      _vm._v(" "),
                                      _vm.highlightedTextIndex !== null &&
                                      _vm.extractedTexts[
                                        _vm.highlightedTextIndex
                                      ]
                                        ? _c("rect", {
                                            attrs: {
                                              x: _vm.extractedTexts[
                                                _vm.highlightedTextIndex
                                              ].pos_x,
                                              y: _vm.extractedTexts[
                                                _vm.highlightedTextIndex
                                              ].pos_y,
                                              width:
                                                _vm.extractedTexts[
                                                  _vm.highlightedTextIndex
                                                ].width,
                                              height:
                                                _vm.extractedTexts[
                                                  _vm.highlightedTextIndex
                                                ].height,
                                              fill: "transparent",
                                              stroke: "#ffc107",
                                              "stroke-width": "10",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.drawingRect
                                        ? _c("rect", {
                                            attrs: {
                                              x: _vm.drawingRect.x,
                                              y: _vm.drawingRect.y,
                                              width: _vm.drawingRect.width,
                                              height: _vm.drawingRect.height,
                                              fill: "rgba(255, 193, 7, 0.2)",
                                              stroke: "#ffc107",
                                              "stroke-width": "5",
                                              "stroke-dasharray": "14 8",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-alert",
                    {
                      staticClass: "mb-3 mt-3",
                      attrs: {
                        show: !!_vm.errorMessage,
                        variant: "danger",
                        dismissible: "",
                      },
                      on: {
                        dismissed: function ($event) {
                          _vm.errorMessage = ""
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.errorMessage) + "\n      "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }